// ============================================
// HOT MESS HORMONE CLUB — THEME JS
// ============================================

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initAddToCartButtons();
});

// ---- CART DRAWER ----

function initCartDrawer() {
  const toggle = document.querySelector('.cart-toggle-btn');
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const closeBtn = document.getElementById('cart-close');

  if (!toggle || !drawer) return;

  toggle.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });
}

function openCart() {
  document.getElementById('cart-drawer')?.classList.add('open');
  document.getElementById('cart-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

// ---- ADD TO CART (collection / featured products) ----

function initAddToCartButtons() {
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added! 🩷';
        showFlash('Added to cart! 🩷');
        updateCartCount();
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        showFlash('Something went wrong. Please try again.');
      });
    });
  });
}

// ---- FLASH MESSAGE ----

function showFlash(message) {
  let flash = document.getElementById('flash-message');
  if (!flash) {
    flash = document.createElement('div');
    flash.id = 'flash-message';
    flash.className = 'flash-message';
    document.body.appendChild(flash);
  }
  flash.textContent = message;
  flash.classList.add('show');
  clearTimeout(flash._timeout);
  flash._timeout = setTimeout(() => flash.classList.remove('show'), 2800);
}

// ---- CART COUNT ----

function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = cart.item_count;
    });
}

// ---- MOBILE MENU (basic toggle) ----

document.querySelector('.mobile-menu-toggle')?.addEventListener('click', () => {
  const nav = document.querySelector('.site-nav');
  if (!nav) return;
  const isOpen = nav.style.display === 'flex';
  nav.style.display = isOpen ? '' : 'flex';
  nav.style.flexDirection = 'column';
  nav.style.position = 'absolute';
  nav.style.top = '72px';
  nav.style.left = '0';
  nav.style.right = '0';
  nav.style.background = 'white';
  nav.style.padding = '16px 24px';
  nav.style.borderBottom = '1px solid var(--light-gray)';
  nav.style.zIndex = '99';
  if (isOpen) nav.removeAttribute('style');
});
